module.exports = __webpack_public_path__ + "static/media/FENGYUN 3C.8999b8c2.czml";